import {configureStore} from "@reduxjs/toolkit";
import sidebarReducer from "./sidebarSlice";
import categoryReducer from "./categorySlice";
import productReducer from "./productSlice";
import cartReducer from "./cartSlice";
import favoriteReducer from "./favoriteSlice";
import searchReducer from "./searchSlice";
import vendorReducer from './vendorSlice'; // Assurez-vous d'importer le bon fichier
import authReducer from "./authSlice";
import orderReducer from "./orderSlice";
import bannerReducer from './bannerSlice';  // Assurez-vous que le chemin est correct



const store = configureStore({
    reducer: {
        sidebar: sidebarReducer,
        category: categoryReducer,
        product: productReducer,
        cart: cartReducer,
        favorite: favoriteReducer,
        search: searchReducer,
        vendor: vendorReducer,// Ajout de la partie vendeur
        auth: authReducer,
        order: orderReducer,
        banners: bannerReducer
    }
});

export default store;